export const svgConstantsProps = {
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    preserveAspectRatio: 'xMidYMid',
}
